import { Injectable } from '@angular/core';
import { LoadingController } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
  providedIn: 'root'
})
//service for displaying messages and/or spinners via LoadingController
export class DisplayloadingService {

  private isShown: boolean = false; //verhindert Mehrfach-Anzeige
  private defaultMessage = "displayloading-service.pleasewait";
  constructor(public loadingController: LoadingController,
    private translate: TranslateService) {
  }


  /**
   * displays a loading spinner with an optional message-text
   * @param messageParams: Optionale variable Parameter für den Übersetzungsservice (bsp. Email-Adresse)
   */
  async presentLoading(message?: string, messageParams?: object): Promise<DisplayloadingService> {
    if (typeof (message) === "undefined") {
      message = this.defaultMessage;
    }
    //Übersetzungsservice (stream funktioniert auch bei spontanem Sprachwechsel)
    if (typeof (messageParams) === "undefined") {
      this.translate.stream(message).subscribe(
        (translation) => {
          message = translation;
        });
    }
    else {
      this.translate.stream(message, messageParams).subscribe(
        (translation) => {
          message = translation;
        });
      return this;
    }


    if (this.isShown !== true) {
      let loading = await this.loadingController.create({
        message: "<b>" + message + "</b>",
        cssClass: "loading-spinner",
        spinner: "lines",
        showBackdrop: true,
        duration: 10000
      });
      await loading.present();
      this.isShown = true;
    }
  }
  async hideLoading() {
    const topnotch = await this.loadingController.getTop();
    if (typeof (topnotch) !== "undefined") {
      this.loadingController.dismiss();
      this.isShown = false;
    }
    try {
      this.loadingController.dismiss();
    }
    catch (e) {
      console.log(e);
    }
  }


  /**
   *
   * @param message: Message to display
   * @param time: how long to display message, default: 5000ms
   * @param type: normal, error, success, default:normal
   * @param bold: display bold or not, default:true
   * @param messageParams: Optionale variable Parameter für den Übersetzungsservice (bsp. Email-Adresse)
   */
  async presentMessage(message: string, time: number = 5000, type: string = 'normal',
    font_weight: boolean = true, messageParams?: object) {
    //Übersetzungsservice (stream funktioniert auch bei spontanem Sprachwechsel)
    if (typeof (messageParams) === "undefined") {
      this.translate.stream(message).subscribe(
        (translation) => {
          console.log(translation)
          message = translation;
        });
    }
    else {
      this.translate.stream(message, messageParams).subscribe(
        (translation) => {
          message = translation;
        });
    }
    if (this.isShown === true) {
      this.hideLoading();
    }
    if (typeof (time) === "undefined") {
      time = 5000;
    }
    if (typeof (type) === "undefined") {
      type = "normal";
    }
    let cssClass: string;
    let icon: string;
    switch (type) {
      case 'normal': cssClass = "loading-spinner";
        icon = '<ion-icon name="alert-circle-sharp"></ion-icon>';
        break;
      case 'error': cssClass = "error-spinner";
        icon = '<ion-icon name="warning-sharp"></ion-icon>';
        break;
      case 'success': cssClass = "success-spinner";
        icon = '<ion-icon name="checkmark-circle-sharp"></ion-icon>';
        break;
      default: cssClass = "loading-spinner";
    }
    let iconMessage: string;
    if (font_weight === true) {
      iconMessage = icon + "<b>" + message + "</b>";
    }
    else {
      iconMessage = icon + message;
    }

    let error = await this.loadingController.create({
      message: iconMessage,
      cssClass: cssClass,
      spinner: null,
      duration: time,
      showBackdrop: true,
      backdropDismiss: true
    });
    error.present();
    //this.isShown=true;
  }

}
